import { type StoreActionApi, createStore, createHook, createActionsHook } from 'react-sweet-state';

import type { ExtractPresetAPI } from '@atlaskit/editor-common/preset';
import type { useUniversalPreset } from '@atlaskit/editor-core/preset-universal';

export type NoteEditorPresetAPI = ExtractPresetAPI<ReturnType<typeof useUniversalPreset>>;

type NotesState = {
	activeNoteId?: string;
};
// Separate store for NoteEditorApi. Necessary to provide strict typechecking that wouldn't work when accessing noteEditorApi as a selector.
type EditorApiState = {
	noteEditorApi?: NoteEditorPresetAPI;
};

const notesInitialState: NotesState = {
	activeNoteId: undefined,
};
const noteEditorApiInitialState: EditorApiState = {
	noteEditorApi: undefined,
};

const notesActions = {
	setActiveNoteId:
		(activeNoteId?: string) =>
		({ setState }: StoreActionApi<NotesState>) => {
			setState({
				activeNoteId,
			});
		},
	resetActiveNoteId:
		() =>
		({ setState }: StoreActionApi<NotesState>) => {
			setState({
				activeNoteId: undefined,
			});
		},
};
const noteEditorApiActions = {
	setNoteEditorApi:
		(noteEditorApi?: NoteEditorPresetAPI) =>
		({ setState }: StoreActionApi<EditorApiState>) => {
			setState({
				noteEditorApi,
			});
		},
	resetNoteEditorApi:
		() =>
		({ setState }: StoreActionApi<EditorApiState>) => {
			setState(noteEditorApiInitialState);
		},
};

const NotesStore = createStore({
	initialState: notesInitialState,
	actions: notesActions,
	name: 'NotesStore',
});
const NoteEditorApiStore = createStore({
	initialState: noteEditorApiInitialState,
	actions: noteEditorApiActions,
	name: 'NoteEditorApiStore',
});

export const useNotesActions = createActionsHook(NotesStore);

const selectActiveNoteId = (state: NotesState): string | undefined => state.activeNoteId;
export const useActiveNoteId = createHook(NotesStore, {
	selector: selectActiveNoteId,
});

export const useNoteEditorApi = createHook(NoteEditorApiStore);
export const useNoteEditorApiActions = createActionsHook(NoteEditorApiStore);
